import React from 'react'
import { LayoutContainer, LayoutForm, HeroImage, ImageSide } from './styled';
import AUTHIMAGE from '../../../../images/authImage.jpg'
import { useLocation } from 'react-router-dom';

const EntryLayout = ({ children, backgroundImage = AUTHIMAGE }) => {
  const location = useLocation()
  const url = location.pathname
  const shouldStretch = url === '/terminos-condiciones';

  return (
    <LayoutContainer>
      <ImageSide>
        <HeroImage src={backgroundImage} alt="Hero background" />
      </ImageSide>
      <LayoutForm stretch={shouldStretch}>{children}</LayoutForm>
    </LayoutContainer>
  );
};

export default EntryLayout;
